import { LightIcon } from "../../assets/icons/LightIcon";
import { MoonIcon } from "../../assets/icons/MoonIcon";
import { useAppContext } from "../Context/AppContext";
import "./ThemeToggle.scss";

function ThemeToggle() {
  const { theme, toggleTheme } = useAppContext();
  const isNightMode = theme === "night";

  return (
    <button
      type="button"
      className={`theme-toggle ${isNightMode ? "theme-toggle--night" : ""}`}
      onClick={toggleTheme}
      aria-label={
        isNightMode ? "Passa a modalità giorno" : "Passa a modalità notte"
      }
      title={isNightMode ? "Modalità giorno" : "Modalità notte"}
    >
      <span className="theme-toggle__icon theme-toggle__icon--day">
        <LightIcon
          width={18}
          height={18}
          strokeColor="currentColor"
          strokeWidth={2}
        />
      </span>
      <span className="theme-toggle__track" aria-hidden="true">
        <span className="theme-toggle__thumb" />
      </span>
      <span className="theme-toggle__icon theme-toggle__icon--night">
        <MoonIcon
          width={18}
          height={18}
          strokeColor="currentColor"
          strokeWidth={2}
        />
      </span>
    </button>
  );
}

export default ThemeToggle;
